import { Link } from 'react-router-dom'
import { motion } from 'motion/react'
import { Button } from '@/components/ui'
import { useSEO } from '@/hooks/useSEO'
import { Home, BookOpen, Briefcase, ArrowRight } from 'lucide-react'

export default function NotFoundPage() {
  useSEO({ title: '404 - Page Not Found' })

  return (
    <div className="flex min-h-[75vh] items-center justify-center px-4">
      <motion.div
        className="mx-auto max-w-lg text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="text-primary/20 mb-2 block text-8xl select-none" aria-hidden>
          &#9833;
        </span>
        <h1 className="text-foreground mb-3 text-5xl font-bold">404</h1>
        <p className="text-muted-foreground mb-8 text-lg">
          This page is resting. Maybe it moved, maybe it never existed.
        </p>

        <div className="mb-12 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Go Home
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/portfolio">
              <Briefcase className="mr-2 h-4 w-4" />
              View Portfolio
            </Link>
          </Button>
        </div>

        <div className="border-border border-t pt-8">
          <p className="text-muted-foreground mb-4 text-sm">Or explore these:</p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
            <Link to="/blog" className="text-primary inline-flex items-center gap-1 hover:underline">
              <BookOpen className="h-3.5 w-3.5" /> Blog
            </Link>
            <Link to="/packages" className="text-primary inline-flex items-center gap-1 hover:underline">
              <ArrowRight className="h-3.5 w-3.5" /> Packages
            </Link>
            <Link to="/services" className="text-primary inline-flex items-center gap-1 hover:underline">
              <ArrowRight className="h-3.5 w-3.5" /> Services
            </Link>
            <Link to="/contact" className="text-primary inline-flex items-center gap-1 hover:underline">
              <ArrowRight className="h-3.5 w-3.5" /> Contact
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  )
}
